// extracted by mini-css-extract-plugin
export default {"containerFields":"SettingDetail_containerFields__qocM7"};